/**
 * Tailwind CSS implementation of ContentHeader primitives
 * Uses Seeds content-header CSS classes from content-header.css
 */

import React from "react";

// Utility for merging class names properly
function cn(
  ...inputs: (string | undefined | null | false | Record<string, boolean>)[]
): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === "string") {
      classes.push(input);
    } else if (typeof input === "object") {
      for (const [key, value] of Object.entries(input)) {
        if (value) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}

interface TypeHeaderContainerProps
  extends React.HTMLAttributes<HTMLDivElement> {
  bordered?: boolean;
}

export const HeaderContainer = ({
  bordered = false,
  className,
  children,
  ...rest
}: TypeHeaderContainerProps) => (
  <div
    className={cn(
      "seeds-content-header",
      { "seeds-content-header-bordered": bordered },
      className
    )}
    {...rest}
  >
    {children}
  </div>
);

export const TriggerButton = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement>
>(({ className, children, type = "button", ...rest }, ref) => (
  <button
    ref={ref}
    type={type}
    className={cn("seeds-content-header-trigger", className)}
    {...rest}
  >
    {children}
  </button>
));

TriggerButton.displayName = "TriggerButton";
